import ChatBodyFooterFiles from "./ChatBodyFooterFiles";

export default ChatBodyFooterFiles;
